<script setup lang="ts">
  import { Text } from "@ui-kit";
</script>

<template>
  <div class="product-not-found" data-testid="product-not-found">
    <Text font="body-medium-16">{{ $t("Товар не найден") }}</Text>
    <Text font="body-regular-14">{{ $t("По вашему запросу ничего не нашлось, попробуйте его изменить") }}</Text>
  </div>
</template>

<style scoped>
  .product-not-found {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 12px;
  }
</style>
